import { render, staticRenderFns } from "./BaseCardRestaurant.vue?vue&type=template&id=c0c764ee&scoped=true&"
import script from "./BaseCardRestaurant.vue?vue&type=script&lang=ts&"
export * from "./BaseCardRestaurant.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardRestaurant.vue?vue&type=style&index=0&id=c0c764ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c764ee",
  null
  
)

export default component.exports